<template>
    <router-link :to="'/myclaims/view/' + item.id" class="claim-link">
        <div :class="[addMarginTop3]" class="claim-list-card">
            <div class="claim-list-card-body">
                <div class="row">
                    <div class="col-md-8">
                        <div class="row">
                            <div class="col-md-4">
                                <p><strong>Reference</strong></p>
                            </div>
                            <div class="col-md-8">
                                <p>{{item.claimReference}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <p><strong>Policy number</strong></p>
                            </div>
                            <div class="col-md-8">
                                <p>{{item.policyNo}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <p><strong>Submitted</strong></p>
                            </div>
                            <div class="col-md-8">
                                <p>{{item.submitted}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <p><strong>Incident type</strong></p>
                            </div>
                            <div class="col-md-8">
                                <p>{{item.incidentType}}</p>
                            </div>
                        </div>
                         <div class="row">
                            <div class="col-md-4">
                                <p><strong>Gadgets</strong></p>
                            </div>
                            <div class="col-md-8">
                                <p v-for="(gadget, index) in item.gadgets" :key="index">{{gadget.displayName}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <p class="float-right" :class="[statusTextColour]"><strong>{{item.status}}</strong></p>
                    </div>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
export default {
  name: 'claimListItem',
  props: {
    item: { required: true }
  },
  computed: {
    statusTextColour () {
      if (this.item.status == 'DECLINED') { return 'text-danger' }

      if (this.item.status == 'APPROVED') { return 'text-success' }

      if (this.item.status == 'UNDER REVIEW') { return 'text-warning' }
    },
    leftBorderColour () {
      if (this.item.status == 'DECLINED') { return 'border-left-red' }

      if (this.item.status == 'APPROVED') { return 'border-left-green' }

      if (this.item.status == 'UNDER REVIEW') { return 'border-left-orange' }
    },
    addMarginTop3 () {
      if (this.$vnode.key > 0) { return 'mt-3' }
    }
  },
  data: () => {
    return {

    }
  }
}
</script>
